import { SourceBasedExpression } from '../Expression.js';
export class AbsExpression extends SourceBasedExpression {
    evaluate(visitor, localVariables) {
        const left = this.getSource().evaluate(visitor, localVariables);
        return Math.abs(left);
    }
}
//# sourceMappingURL=AbsExpression.js.map